var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "PortalWidget",
    { attrs: { widget: _vm.widgetTitle } },
    [
      !_vm.isLoading
        ? _c("div", { staticClass: "form-horizontal" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { staticClass: "col-sm-3 control-label" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("ACCOUNT_BILLING_BALANCE_CURRENT")) +
                    "\n        "
                ),
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.right",
                      value: _vm.$t("ACCOUNT_BILLING_BALANCE_CURRENT_TT"),
                      expression: "$t('ACCOUNT_BILLING_BALANCE_CURRENT_TT')",
                      modifiers: { right: true }
                    }
                  ],
                  staticClass: "fa fa-question-circle m-l-5"
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-1 p-t-7" }, [
                _vm._v(
                  "\n        $" +
                    _vm._s(_vm.billingPlan.accountBalance) +
                    "\n      "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "col-sm-9 col-sm-offset-3" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-lg btn-primary",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.addBalance()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("ACCOUNT_BILLING_BALANCE_ADD_BUTTON")) +
                        "\n        "
                    )
                  ]
                )
              ])
            ])
          ])
        : _c(
            "div",
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "LOADING",
                    expression: "'LOADING'"
                  }
                ]
              })
            ],
            1
          ),
      _vm._v(" "),
      _vm.showAddFunds
        ? _c("AddFundsModal", { on: { closeModal: _vm.closeModal } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }